module.exports = __webpack_public_path__ + "img/img-18.cce50a90.png";